import { useTheme } from '@simplywallst/ui-core';
import TitleText from '../TitleText';
import { useState } from 'react';
import { MAIN_NODES } from '../Sankey/const';

type Props = {
  // bgXCoord: number;
  // textXCoord: number;
  x: number;
  bgColor: string;
  textColor: string;
  textAnchor: 'start' | 'middle' | 'end';
  children: string;
};

export const TitleColor = ({
  x,
  bgColor,
  textColor,
  textAnchor,
  children,
}: Props) => {
  const [width, setWidth] = useState(0);
  const theme = useTheme();

  const handleWidthUpdate = (width: number) => {
    setWidth(width);
  };
  const isTitleColor = MAIN_NODES.includes(children);
  const padding = 12;

  return (
    <>
      {isTitleColor && (
        <rect
          width={width + padding}
          height={25}
          x={x}
          y={-theme.x7spacePx}
          rx="6"
          fill={bgColor}
          transform={`translate(-${(width + padding) / 2})`}
        />
      )}
      <TitleText
        x={x}
        fill={isTitleColor ? textColor : theme.color.paleWhite}
        onWidthUpdate={handleWidthUpdate}
        textAnchor={textAnchor}
      >
        {children}
      </TitleText>
    </>
  );
};
